
import './intro.css'
import propic from '../image/propic.jpg'
import React, { useContext } from "react";
import { themeContext } from "../../Context";
export const Intro = () => {
    const theme = useContext(themeContext);
    const darkMode = theme.state.darkMode;
    return (
        <div className='intro' id='about'>
            <div className="i-left">
                <div className='i-name'>
                    <div className="wrapper">
                        <div className="static-txt"  style={{ color: darkMode ? "white" : "" }}>I'm <span className="Aman">Aman Dubey</span></div>
                        <ul className="dynamic-txts" >
                        
                            <li><span>Full Stack Developer</span></li>
                       
                        </ul>
                    </div>
                    <span> An Observent programmer  and aspiring full stack developer . Having expertise
                        in developing web pages using HTML5, CSS
                        Java script, React Js,Redux, Express & MongoDb. </span>
                    <span> Apart from coding  some other activities i love to do is Hiking,treking, lisening music, and playing Cricket</span>
                </div>
                <div className='i-icons'>
                    <a href="https://github.com/amananshul" target="blank"><i className='fa fa-github'></i></a>

                    <a href="https://www.linkedin.com/in/aman-dubey-616243248" target="blank"><i className='fa fa-linkedin'></i></a>

                    <a href="https://www.instagram.com/aman_anshul/" target="blank"><i className='fa fa-instagram'></i></a>
                </div>
            </div>
            <div className='i-right'>
                <img className="pro-img" src={propic} alt="" />
            </div>

        </div>
    )
}
